import React from 'react';
import { Button, Tooltip } from 'antd';
import { useFilterSortContext } from '../context/filter-sort-context';

export const FilterButton = (): JSX.Element => {
  const {
    onFilterDrawerHandler,
  } = useFilterSortContext();
  return (
    <Tooltip title="Filters">
      <Button
        onClick={() => onFilterDrawerHandler()}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px',
          backgroundColor: '#F7F8FA',
          borderColor: '#190952',
        }}
        icon={(
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6666 2H1.33325L6.66659 8.30667V12.6667L9.33325 14V8.30667L14.6666 2Z" stroke="#190952" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

        )}
      />
    </Tooltip>
  );
};
